import productContentWidget from '../../widgets/general/product-content'
import productHeroWidget from '../../widgets/general/product-hero'

const createProductLayoutWidgets = () => [
  productContentWidget(),
  productHeroWidget()
]

export default createProductLayoutWidgets
